module.exports = __webpack_public_path__ + "img/undo.bcdd59cf.svg";